import axios from "axios";

const baseUrl = "/AutoConnectSSO/api/Shared/SsoApplication/SsoApplication";

const instance = axios.create({
  baseURL: baseUrl,
  withCredentials: true
});

function getUrl(target: string) {
  return `/?target=${encodeURIComponent(target)}`;
}

async function getSsoApplicationByUri(target: string) {
  const url = getUrl(target);
  const response = await instance.get(url);
  return response.data;
}

export const SsoApplicationService = {
  getSsoApplicationByUri
};
